<template>
    <div class="row" v-if="isValid('CanViewHoldServiceInvoices') || isValid('CanViewPaidServiceInvoices') || isValid('CanViewCreditServiceInvoices')" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'direction: rtl'">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'arabicLanguage'" v-if="isDayAlreadyStart">
            <div class="row mb-4">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <h5 class="page_title">Sale Service Invoice</h5>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link :to="'/StartScreen'"><a href="javascript:void(0)"> {{ $t('Sale.Home') }}</a></router-link></li>
                            <li class="breadcrumb-item active" aria-current="page">Sale Service Invoice</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                    <router-link :to="'/StartScreen'"><a href="javascript:void(0)" class="btn btn-outline-danger"> {{ $t('Sale.Close') }}</a></router-link>
                </div>
            </div>
            <div class="card ">
                <div class="card-header ">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div class="form-group">
                                <label>{{ $t('Sale.SearchOfInvoice') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" name="search" id="search" :placeholder="$t('Sale.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label>{{ $t('Sale.FromDate') }}</label>
                                <datepicker v-model="fromDate" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label>{{ $t('Sale.ToDate') }}</label>
                                <datepicker v-model="toDate" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-2">
                            <label style="color:transparent;">Filter</label>
                            <div class="form-group" v-on:click="AdvanceFilter">
                                <a href="javascript:void(0)" class="btn btn-outline-primary serch_btn_top_margin"><i class="fa fa-filter"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="row pb-3" v-if="advanceFilters">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group" style="width:100%" v-if="fromDate==toDate">
                                <label>From Time</label><br />
                                <vue-timepicker v-model="fromTime" format="hh:mm A" input-width="100%" />
                            </div>
                            <div class="form-group" style="width:100%" v-else>
                                <label>From Time <span style="font-size:9px">(Times Filter Apply on Same Date)</span></label><br />
                                <vue-timepicker v-model="fromTime" disabled format="hh:mm A" input-width="100%" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <div class="form-group" style="width:100%" v-if="fromDate==toDate">
                                <label>To Time </label><br />
                                <vue-timepicker v-model="toTime" format="hh:mm A" input-width="100%" />
                            </div>
                            <div class="form-group" style="width:100%" v-else>
                                <label>To Time <span style="font-size:9px">(Times Filter Apply on Same Date)</span></label><br />
                                <vue-timepicker v-model="toTime" disabled format="hh:mm A" input-width="100%" />
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 ">
                            <label class="text  font-weight-bolder"> {{ $t('Sale.Counter') }}:</label>
                            <terminal-dropdown v-model="terminalId" :terminalType="terminalType" :allShow="allShow" />

                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                            <label class="text  font-weight-bolder">  {{$t('Sale.User1')}}:</label>
                            <usersDropdown v-model="user" v-on:input="GetUserId(user)" :isloginhistory="isloginhistory" />

                        </div>
                    </div>
                </div>
            </div>


            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class=" mb-1">
                                <div v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? '' : 'arabicLanguage'">
                                    <ul class="nav nav-tabs" data-tabs="tabs">
                                        <li class="nav-item" v-if="isValid('CanViewHoldServiceInvoices')"><a class="nav-link" v-bind:class="{active:active == 'Hold'}" v-on:click="makeActive('Hold')" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">{{ $t('Sale.Hold') }}</a></li>
                                        <li class="nav-item" v-if="isValid('CanViewPaidServiceInvoices')"><a class="nav-link" v-bind:class="{active:active == 'Paid'}" v-on:click="makeActive('Paid')" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">{{ $t('Sale.Paid') }}</a></li>
                                        <li class="nav-item" v-if="isValid('CanViewCreditServiceInvoices')"><a class="nav-link" v-bind:class="{active:active == 'Credit'}" v-on:click="makeActive('Credit')" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">{{ $t('Sale.Credit') }}</a></li>

                                    </ul>
                                </div>
                            </div>
                            <div class="tab-content mt-3" id="nav-tabContent">
                                <div v-if="active == 'Hold'">
                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg">
                                            <thead class="">
                                                <tr>
                                                    <th style="width:40px;">#</th>
                                                    <th style="width:105px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.InvoiceNo') }}
                                                    </th>
                                                    <th style="width:105px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.SONumber') }}
                                                    </th>
                                                    <!--<th v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.Type') }}
                                                    </th>-->
                                                    <th style="width: 125px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.Date') }}
                                                    </th>
                                                    <th style="width: 220px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="english=='true'">
                                                        {{ $t('Sale.CustomerName') |englishLanguage}}
                                                    </th>
                                                    <th style="width: 220px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isOtherLang()">
                                                        {{ $t('Sale.CustomerNameArabic') |arabicLanguage}}
                                                    </th>
                                                    <th style="width: 120px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.CreatedBy') }}
                                                    </th>
                                                    <!--<th v-if="isDayStarts=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('DailyExpense.CounterId') }}
                                                    </th>-->
                                                    <th style="width: 120px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.NetAmount') }}
                                                    </th>
                                                    <th style="width: 200px;" class="text-center">
                                                        {{ $t('Sale.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(sale,index) in saleList" v-bind:key="index">
                                                    <td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*10)-10) +(index+1)}}
                                                    </td>
                                                    <td v-if="isValid('CanEditHoldServiceInvoices') && (isValid('CreditServiceInvoices') || isValid('CashServiceInvoices'))" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        <strong>
                                                            <a href="javascript:void(0)" v-on:click="EditSale(sale.id)">{{sale.registrationNumber}}</a>
                                                        </strong> <br />
                                                        <span class="small badge badge-success">{{sale.isCredit ? 'Credit':'Cash'}}</span>
                                                    </td>
                                                    <td v-else v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.registrationNumber}}
                                                        <span class="small badge badge-success">{{sale.isCredit ? 'Credit':'Cash'}}</span>
                                                    </td>
                                                    <!--<td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.isCredit ? 'Credit':'Cash'}}
                                                    </td>-->

                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.saleOrderNo==null? '---':sale.saleOrderNo}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{getDate(sale.date)}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="english=='true'">
                                                        {{sale.customerName}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isOtherLang()">
                                                        {{sale.customerNameArabic}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.userName}} <br />
                                                        <span v-if="isDayStarts=='true'">{{sale.counterName}}</span>
                                                    </td>
                                                    <!--<td v-if="isDayStarts=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.counterName}}
                                                    </td>-->
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{currency}}  {{parseFloat(sale.netAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                                                        <button class="btn btn-primary btn-sm btn-icon" v-on:click="DuplicateInvoice(sale.id)" v-if="isValid('CanDuplicateServiceInvoices') && (isValid('CreditServiceInvoices') || isValid('CashServiceInvoices')) "><i class="fas fa-copy"></i></button>
                                                        <button class="btn btn-primary btn-sm btn-icon mr-1  ml-1" v-on:click="ViewInvoiceTemplate(sale.id)" title="Template View" v-if="isValid('CanViewServiceInvoiceDetail') && printTemplate=='Template6'"><i class="fas fa-eye"></i></button>
                                                        <button class="btn btn-primary btn-sm btn-icon mr-1  ml-1" v-on:click="ViewInvoice(sale.id)" v-if="isValid('CanViewServiceInvoiceDetail') && printTemplate!='Template6'"><i class="fas fa-eye"></i></button>

                                                        <a href="javascript:void(0)" title="A4" class="btn btn-primary btn-sm btn-icon " v-on:click="PrintInvoice(sale.id, 'print')" v-if="isValid('CanA4ServicePrint') "><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" title="A4" class="btn btn-primary btn-sm btn-icon  ml-1 mr-1" v-on:click="PrintInvoice(sale.id, 'download')" v-if="isValid('CanA4ServicePrint') "><i class="far fa-file-pdf"></i></a>

                                                        <!--<a href="javascript:void(0)" title="POS" class="btn btn-primary btn-sm btn-icon ml-1 mr-1" v-on:click="PrintInvoicePos(sale.id, sale.counterName)" v-if="isValid('CanPosPrint') "><i class=" fa fa-print"></i></a>-->
                                                        <button class="btn btn-danger btn-sm btn-icon " @click="RemoveSale(sale.id)" v-if="isValid('CanDeleteHoldServiceInvoices') "><i class="fa fa-trash"></i></button>
                                                        <a href="javascript:void(0)" title="Email" class="btn btn-primary btn-sm btn-icon " v-on:click="sendEmail(sale.id)" v-if="isValid('CanSendSaleEmailAsLink') || isValid('CanSendSaleEmailAsPdf') "><i class=" far fa-envelope"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('Pagination.ShowingEntries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('Pagination.Showing') }} {{currentPage}}  {{ $t('Pagination.to') }} {{rowCount}}  {{ $t('Pagination.of') }} {{rowCount}}  {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage===1"> {{ $t('Pagination.Showing') }} {{currentPage}} {{ $t('Pagination.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{currentPage*10}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                        <span v-else-if="currentPage === pageCount"> {{ $t('Pagination.Showing') }} {{(currentPage*10)-9}} {{ $t('Pagination.to') }} {{rowCount}} {{ $t('Pagination.of') }} {{rowCount}} {{ $t('Pagination.entries') }}</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()" v-if="($i18n.locale == 'en' ||isLeftToRight())">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                        <div class="overflow-auto" v-on:click="getPage()" v-else>
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="الأولى"
                                                          prev-text="السابقة"
                                                          next-text="التالية"
                                                          last-text="الأخيرة"></b-pagination>
                                        </div>
                                    </div>


                                </div>
                                <div v-if="active == 'Paid'">
                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg">
                                            <thead class="">
                                                <tr>
                                                    <th style="width:40px;">#</th>
                                                    <th style="width:105px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.InvoiceNo') }}
                                                    </th>
                                                    <th style="width:105px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.SONumber') }}
                                                    </th>
                                                    <!--<th v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.Type') }}
                                                    </th>-->
                                                    <th style="width: 125px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">



                                                        {{ $t('Sale.Date') }}
                                                    </th>
                                                    <th style="width: 220px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="english=='true'">
                                                        {{ $t('Sale.CustomerName') |englishLanguage}}
                                                    </th>
                                                    <th style="width: 220px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isOtherLang()">
                                                        {{ $t('Sale.CustomerNameArabic') |arabicLanguage}}
                                                    </th>
                                                    <th style="width: 120px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.CreatedBy') }}
                                                    </th>
                                                    <!--<th v-if="isDayStarts=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('DailyExpense.CounterId') }}
                                                    </th>-->
                                                    <th style="width: 120px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">



                                                        {{ $t('Sale.NetAmount') }}
                                                    </th>
                                                    <th style="width: 180px;" class="text-center">
                                                        {{ $t('Sale.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(sale,index) in saleList" v-bind:key="index">
                                                    <td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*10)-10) +(index+1)}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        <strong>
                                                            {{sale.registrationNumber}}
                                                        </strong> <br />
                                                        <span class="small badge badge-success">{{($i18n.locale == 'en' ||isLeftToRight()) ? 'paid' : 'دفع'}}</span>
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.saleOrderNo==null? '---':sale.saleOrderNo}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{getDate(sale.date)}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="english=='true'">
                                                        {{sale.customerName}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isOtherLang()">
                                                        {{sale.customerNameArabic}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.userName}} <br />
                                                        <span v-if="isDayStarts=='true'">{{sale.counterName}}</span>
                                                    </td>
                                                    <!--<td v-if="isDayStarts=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.counterName}}
                                                    </td>-->
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">



                                                        {{currency}} {{parseFloat(sale.netAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-bind:style="isDisabled ? 'pointer-events: none;' : ''">
                                                        <button class="btn btn-primary btn-sm btn-icon" v-on:click="DuplicateInvoice(sale.id)" v-if="isValid('CanDuplicateServiceInvoices') && (isValid('CreditServiceInvoices') || isValid('CashServiceInvoices'))"><i class="fas fa-copy"></i></button>
                                                        <button class="btn btn-primary btn-sm btn-icon mr-1  ml-1" v-on:click="ViewInvoiceTemplate(sale.id)" title="Template View" v-if="isValid('CanViewServiceInvoiceDetail') && printTemplate=='Template6'"><i class="fas fa-eye"></i></button>
                                                        <button class="btn btn-primary btn-sm btn-icon mr-1  ml-1" v-on:click="ViewInvoice(sale.id)" v-if="isValid('CanViewServiceInvoiceDetail') && printTemplate!='Template6'"><i class="fas fa-eye"></i></button>
                                                        <a href="javascript:void(0)" title="A4" class="btn btn-primary btn-sm btn-icon" v-on:click="PrintInvoice(sale.id, 'print')" v-if="isValid('CanA4ServicePrint') "><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" title="A4" class="btn btn-primary btn-sm btn-icon  ml-1 mr-1" v-on:click="PrintInvoice(sale.id, 'download')" v-if="isValid('CanA4ServicePrint') "><i class="far fa-file-pdf"></i></a>

                                                        <!--<a href="javascript:void(0)" title="POS" class="btn btn-primary btn-sm btn-icon ml-1 mr-1" v-on:click="PrintInvoicePos(sale.id,sale.counterName)" v-if="isValid('CanPosPrint') "><i class=" fa fa-print"></i></a>-->
                                                        <a href="javascript:void(0)" title="Email" class="btn btn-primary btn-sm btn-icon " v-on:click="sendEmail(sale.id)" v-if="isValid('CanSendSaleEmailAsLink') || isValid('CanSendSaleEmailAsPdf') "><i class=" far fa-envelope"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          :key="rendr"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                    </div>

                                </div>
                                <div v-if="active == 'Credit'">
                                    <div class="table-responsive">
                                        <table class="table table-hover table-striped table_list_bg">
                                            <thead class="">
                                                <tr>
                                                    <th style="width:40px;">#</th>
                                                    <th style="width:105px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.InvoiceNo') }}
                                                    </th>
                                                    <th style="width:105px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.SONumber') }}
                                                    </th>
                                                    <!--<th v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.Type') }}
                                                    </th>-->
                                                    <th style="width: 125px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.Date') }}
                                                    </th>
                                                    <th style="width: 220px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="english=='true'">

                                                        {{ $t('Sale.CustomerName') |englishLanguage}}
                                                    </th>
                                                    <th style="width: 220px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isOtherLang()">
                                                        {{ $t('Sale.CustomerNameArabic') |arabicLanguage}}
                                                    </th>
                                                    <th style="width: 120px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.CreatedBy') }}
                                                    </th>
                                                    <!--<th v-if="isDayStarts=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('DailyExpense.CounterId') }}
                                                    </th>-->
                                                    <th style="width: 120px;" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{ $t('Sale.NetAmount') }}
                                                    </th>
                                                    <th style="width: 180px;" class="text-center">

                                                        {{ $t('Sale.RePrint') }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(sale,index) in saleList" v-bind:key="index">
                                                    <td v-if="currentPage === 1">
                                                        {{index+1}}
                                                    </td>
                                                    <td v-else>
                                                        {{((currentPage*10)-10) +(index+1)}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        <strong>
                                                            {{sale.registrationNumber}}
                                                        </strong> <br />
                                                        <div class="badge badge-danger" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="sale.partiallyInvoices==1">
                                                            {{($i18n.locale == 'en' ||isLeftToRight())?'Un-Paid':'غير مدفوعة'}}
                                                        </div>
                                                        <div class="badge badge-primary" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="sale.partiallyInvoices==2">
                                                            {{($i18n.locale == 'en' ||isLeftToRight())?' Partially Paid':'المدفوعة جزئيا'}}

                                                        </div>
                                                        <div class="badge badge-success" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="sale.partiallyInvoices==3">

                                                            {{($i18n.locale == 'en' ||isLeftToRight())?' Fully Paid':'مدفوعة بالكامل'}}
                                                        </div>
                                                    </td>
                                                    <!--<td>
                                                        <div class="badge badge-danger" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="sale.partiallyInvoices==1">
                                                            {{($i18n.locale == 'en' ||isLeftToRight())?'Un-Paid':'غير مدفوعة'}}
                                                        </div>
                                                        <div class="badge badge-primary" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="sale.partiallyInvoices==2">
                                                            {{($i18n.locale == 'en' ||isLeftToRight())?' Partially Paid':'المدفوعة جزئيا'}}

                                                        </div>
                                                        <div class="badge badge-success" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="sale.partiallyInvoices==3">
                                                            {{($i18n.locale == 'en' ||isLeftToRight())?' Fully Paid':'مدفوعة بالكامل'}}
                                                        </div>
                                                    </td>-->
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.saleOrderNo==null? '---':sale.saleOrderNo}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{getDate(sale.date)}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="english=='true'">
                                                        {{sale.customerName}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-if="isOtherLang()">
                                                        {{sale.customerNameArabic}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.userName}}
                                                    </td>
                                                    <!--<td v-if="isDayStarts=='true'" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{sale.counterName}}
                                                    </td>-->
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        {{currency}} {{parseFloat(sale.netAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                                    </td>
                                                    <td v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                                        <button class="btn btn-primary btn-sm btn-icon" v-on:click="DuplicateInvoice(sale.id)" v-if="isValid('CanDuplicateServiceInvoices') && (isValid('CreditServiceInvoices') || isValid('CashServiceInvoices')) "><i class="fas fa-copy"></i></button>
                                                        <button class="btn btn-primary btn-sm btn-icon mr-1  ml-1" v-on:click="ViewInvoiceTemplate(sale.id)" title="Template View" v-if="isValid('CanViewServiceInvoiceDetail') && printTemplate=='Template6'"><i class="fas fa-eye"></i></button>
                                                        <button class="btn btn-primary btn-sm btn-icon mr-1  ml-1" v-on:click="ViewInvoice(sale.id)" v-if="isValid('CanViewServiceInvoiceDetail') && printTemplate!='Template6'"><i class="fas fa-eye"></i></button>
                                                        <a href="javascript:void(0)" title="A4" class="btn btn-primary btn-sm btn-icon" v-on:click="PrintInvoice(sale.id, 'print')" v-if="isValid('CanA4ServicePrint') "><i class=" fa fa-print"></i></a>
                                                        <a href="javascript:void(0)" title="A4" class="btn btn-primary btn-sm btn-icon  ml-1 mr-1" v-on:click="PrintInvoice(sale.id, 'download')" v-if="isValid('CanA4ServicePrint') "><i class="far fa-file-pdf"></i></a>

                                                        <!--<a href="javascript:void(0)" title="POS" class="btn btn-primary btn-sm btn-icon ml-1 mr-1" v-on:click="PrintInvoicePos(sale.id,sale.counterName)" v-if="isValid('CanPosPrint') "><i class=" fa fa-print"></i></a>-->
                                                        <a href="javascript:void(0)" title="Email" class="btn btn-primary btn-sm btn-icon " v-on:click="sendEmail(sale.id)" v-if="isValid('CanSendSaleEmailAsLink') || isValid('CanSendSaleEmailAsPdf') "><i class=" far fa-envelope"></i></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="float-left">
                                        <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                    </div>
                                    <div class="float-right">
                                        <div class="overflow-auto" v-on:click="getPage()">
                                            <b-pagination pills size="lg" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          :key="rendr"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
        <div class="col-lg-6 col-sm-6 ml-auto mr-auto" v-else>
            <div class="card p-3 text-center " v-if="bankDetail">
                <h4 class="">{{ $t('FirstStartInvoice') }}</h4>
                <router-link :to="{path: '/WholeSaleDay', query: { token_name:'DayStart_token', fromDashboard:'true' } }"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('Dashboard.DayStart') }}</a></router-link>
            </div>
            <div class="card p-3 text-center " v-else>
                <h4 class="">{{ $t('FirstStartInvoice') }}</h4>
                <router-link :to="{path: '/dayStart', query: { token_name:'DayStart_token', fromDashboard:'true' } }"><a href="javascript:void(0)" class="btn btn-outline-danger ">{{ $t('Dashboard.DayStart') }}</a></router-link>
            </div>
        </div>
        <sale-invoice-service-default-Download :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="download" @close="download=false" />
        <ObaagestSaleInvoice :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" :saleSizeAssortment="saleSizeAssortment" v-if="printDetails.length != 0 && printSize=='A4' && printTemplate=='Template8' && isPrint && !download" v-bind:key="printRender" />

        <sale-invoice-service-default-Download :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="download && printTemplate=='Default'" @close="download=false" />
        <SmartDigitalInvoiceDownload :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="download && printTemplate=='Template6'" @close="download=false" />
        <SmartDigitalInvoice :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printSize=='A4' && printTemplate=='Template6' && isPrint && !download" v-bind:key="printRender" />

        <sale-invoice-default :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printSize=='A4' && printTemplate=='Default' && isPrint && !download" v-bind:key="printRender" />
        <!--<saleInvoice-template-one :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printSize=='A4' && printTemplate=='Template1'" v-bind:key="printRender" />
    <saleinvoice-dotMatrixprint :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printSize=='A4' && printTemplate=='Template2'" v-bind:key="printRender" />-->
        <sale-service-invoice-a4 :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && printSize=='A4' && printTemplate=='Template3' && isPrint && !download" v-bind:key="printRender" />
        <!--<sale-service-invoice-a4 :printDetails="printDetails" :isTouchScreen="sale" :headerFooter="headerFooter" v-if="printDetails.length != 0 && isPrint && !download" v-bind:key="printRender" />-->


        <email-compose :show="emailComposeShow" v-if="emailComposeShow" @close="emailComposeShow = false" :documentId="saleId" :headerFooter="headerFooter" :formName="'Invoice'"></email-compose>
    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>

<script>
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
    import clickMixin from '@/Mixins/clickMixin'
    import moment from "moment";
    export default {
        components: {
            VueTimepicker
        },
        mixins: [clickMixin],
        data: function () {
            return {
                saleId: '',
                isPrint: false,
                download: false,
                emailComposeShow: false,
                bankDetail: false,
                printSize: '',
                printTemplate: '',
                filePath: null,
                fromDate: '',
                toDate: '',
                user: '',
                fromTime: '',
                toTime: '',
                userId: '',
                terminalId: '',
                active: 'Hold',
                isDisabled: false,
                advanceFilters: false,
                printInterval: '',
                search: '',
                english: '',
                arabic: '',
                searchQuery: '',
                saleList: [],
                purchasePostList: [],
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                currency: '',

                selected: [],
                selectAll: false,
                updateApprovalStatus: {
                    id: '',
                    approvalStatus: ''
                },

                printDetails: [],
                printDetailsPos: [],
                printRender: 0,
                printRenderPos: 0,
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
                companyId: '00000000-0000-0000-0000-000000000000',
                CompanyID: '',
                UserID: '',
                employeeId: '',
                isDayAlreadyStart: false,
                IsProduction: false,
                AllowAll: false,
                sale: false,
                isDayStarts: '',
                rendr: 0,
                counter: 0,
                terminalType: 'CashCounter',
                allShow: true,
                isloginhistory: true,
                overWrite: false,
                businessLogo: '',
                businessNameArabic: '',
                businessNameEnglish: '',
                businessTypeArabic: '',
                businessTypeEnglish: '',
                companyNameArabic: '',
                companyNameEnglish: ''


            }
        },
        watch: {
            search: function (search) {
                this.getData(search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
            },
            fromDate: function (fromDate) {
                this.counter++;
                if (this.counter != 1) {
                    localStorage.setItem('fromDate', fromDate);
                    this.getData(this.search, this.currentPage, this.active, fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
                }
            },
            toDate: function (toDate) {
                this.counter++;
                if (this.counter != 2) {
                    localStorage.setItem('toDate', toDate);
                    this.getData(this.search, this.currentPage, this.active, this.fromDate, toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
                }
            },
            fromTime: function () {

                if (this.advanceFilters) {

                    if (this.fromTime.split(' ')[1] != 'A') {
                        this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
                    }
                }
            },
            toTime: function () {
                if (this.advanceFilters) {
                    if (this.toTime.split(' ')[1] != 'A') {
                        this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
                    }
                }
            },
            userId: function () {
                if (this.advanceFilters) {
                    if (this.toTime.split(' ')[1] != 'A' && this.fromTime.split(' ')[1] != 'A') {
                        this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
                    }
                    else {
                        this.fromTime = '';
                        this.toTime = '';
                        this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);

                    }
                }
            },
            terminalId: function () {
                if (this.advanceFilters) {
                    if (this.toTime.split(' ')[1] != 'A' && this.fromTime.split(' ')[1] != 'A') {
                        this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
                    }
                    else {
                        this.fromTime = '';
                        this.toTime = '';
                        this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);

                    }
                }
            }
        },
        methods: {
            sendEmail: function (saleId) {
                this.saleId = saleId
                this.emailComposeShow = true;
            },
            GetUserId: function (x) {
                this.userId = x.id;
            }
            , getDate: function (date) {
                return moment(date).format('LLL');
            },
            PrinterInterval: function () {
                var root = this;

                this.printInterval = setInterval(() => {
                    root.isDisabled = false;
                }, 3000);
            },
            ClearIntervalStatus: function () {
                clearInterval(this.printInterval)
            },
            isDayStart: function () {
                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.loading = true;
                root.$https.get('/Product/IsDayStart?userId=' + this.UserID + '&employeeId=' + this.employeeId, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.isDayStart == true) {
                            root.isDayAlreadyStart = true;
                            localStorage.setItem('token', response.data.token);
                        } else {
                            root.isDayAlreadyStart = false;
                        }
                        root.loading = false;

                    });
            },

            EditSale: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/SaleDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {

                            root.$router.push({
                                path: '/addSaleService',
                                query: {
                                    data: response.data,
                                    page: root.currentPage
                                }

                            })
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: "Something Went Wrong",
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                icon: 'error',
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    },
                        function (error) {
                            console.log(error);
                        });
            },
            EditSaleTouch: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/SaleDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.$router.push({
                                path: '/TouchScreen',
                                query: { data: response.data }
                            })
                        }
                    },
                        function (error) {
                            console.log(error);
                        });
            },
            DuplicateInvoice: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/SaleDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            response.data.isDuplicate = true;
                            root.$router.push({
                                path: '/addSaleService',
                                query: { data: response.data, isDuplicate: 'true'  }
                            })
                        }
                    },
                        function (error) {
                            console.log(error);
                        });
            },
            ViewInvoice: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/SaleDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.$router.push({
                               path: '/InvoiceServiceView',
                                //path: '/SaleServiceView',
                                query: {
                                    data: response.data,
                                    page: root.currentPage,
                                    active: root.active
                                }
                            })
                        }
                    },
                        function (error) {
                            console.log(error);
                        });
            },
            goToPaymentDetail: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/SaleDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.$router.push({
                                path: '/SalePaymentDetail',
                                query: { data: response.data }
                            })
                        }
                    },
                        function (error) {
                            console.log(error);
                        });
            },

            AdvanceFilter: function () {

                this.advanceFilters = !this.advanceFilters;
                if (this.advanceFilters == false) {
                    this.fromTime = '';
                    this.toTime = '';
                    this.userId = '';
                    this.terminalId = '';
                }


            },
            makeActive: function (item) {

                this.active = item;
                this.selectAll = false;
                this.selected = [];
                this.getData(this.search, 1, item, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
            },
            getPage: function () {

                this.getData(this.search, this.currentPage, this.active, this.fromDate, this.toDate, this.fromTime, this.toTime, this.terminalId, this.userId);
            },
            getData: function (search, currentPage, status, fromDate, toDate, fromTime, toTime, terminalId, userId) {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                localStorage.setItem('currentPage', this.currentPage);
                localStorage.setItem('active', this.active);
                this.$https.get('/Sale/SaleServiceList?status=' + status + '&searchTerm=' + search + '&pageNumber=' + currentPage + '&fromDate=' + fromDate + '&toDate=' + toDate + '&fromTime=' + fromTime + '&toTime=' + toTime + '&terminalId=' + terminalId + '&userId=' + userId, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {

                        if (response.data != null) {
                            root.currentPage = response.data.currentPage;
                            root.pageCount = response.data.pageCount;
                            root.rowCount = response.data.rowCount;
                            root.saleList = response.data.results;
                            root.currentPage = currentPage;
                            root.rendr++;
                        }
                    }).catch(error => {
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Error!',
                                text: error.response.data,
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                    });
            },
            //getPostData: function (search, currentPage, status) {
            //    var root = this;
            //    var token = '';
            //    if (this.$session.exists()) {
            //        token = localStorage.getItem('token');
            //    }
            //    this.$https.get('/PurchasePost/PurchasePostList?status=' + status + '&searchTerm=' + search + '&pageNumber=' + currentPage, { headers: { "Authorization": `Bearer ${token}` } })

            //        .then(function (response) {
            //

            //            root.$store.dispatch('GetPurchasePostList', response.data.results);
            //            root.purchasePostList = response.data.results;
            //            root.pageCount = response.data.pageCount;
            //            root.rowCount = response.data.rowCount;

            //        },
            //            function () {
            //                root.$swal({
            //                    title: "Error!",
            //                    text: "Something went wrong",
            //                    type: 'error',
            //                    confirmButtonClass: "btn btn-danger",
            //                    buttonsStyling: false
            //                });
            //            });
            //},

            RemoveSale: function (id) {
                var root = this;
                this.$swal({
                    title: "Are you sure?",
                    text: "You will not be able to recover this!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, delete it!",
                    closeOnConfirm: false,
                    closeOnCancel: false
                }).then(function (result) {
                    if (result) {

                        var token = '';
                        if (root.$session.exists()) {
                            token = localStorage.getItem('token');
                        }
                        root.$https.get('/Sale/DeleteSale?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                            .then(function (response) {
                                if (response.data.message.id != '00000000-0000-0000-0000-000000000000') {

                                    root.saleList.splice(root.saleList.findIndex(function (i) {
                                        return i.id === response.data.message.id;
                                    }), 1);
                                    root.$swal({
                                        title: 'Deleted!',
                                        text: response.data.message.isAddUpdate,
                                        type: 'success',
                                        confirmButtonClass: "btn btn-success",
                                        buttonsStyling: false
                                    });
                                } else {
                                    root.$swal({
                                        title: "Error!",
                                        text: response.data.message.isAddUpdate,
                                        type: 'error',
                                        confirmButtonClass: "btn btn-danger",
                                        buttonsStyling: false
                                    });
                                }
                            },
                                function () {

                                    root.$swal({
                                        title: "Error!",
                                        text: "Delete UnSuccessfully",
                                        type: 'error',
                                        confirmButtonClass: "btn btn-danger",
                                        buttonsStyling: false
                                    });
                                });
                    }
                    else {
                        this.$swal('Cancelled', 'Your invoice is still intact', 'info');
                    }
                });
            },
            AddSale: function () {
                this.$router.push('/addSaleService');
            },
            getBase64Image: function (path) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.headerFooter.company.logoPath = 'data:image/png;base64,' + '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';

                if (path != null && path != '' && path != undefined) {
                    root.$https.get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                        if (response.data != null) {
                            root.filePath = response.data;
                            root.headerFooter.company.logoPath = 'data:image/png;base64,' + root.filePath;
                        }

                    });
                }


            },
            GetHeaderDetail: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;
                            root.GetInvoicePrintSetting();


                            if (root.overWrite) {

                                root.headerFooter.company.nameArabic = root.businessNameArabic;
                                root.headerFooter.company.nameEnglish = root.businessNameEnglish;
                                root.headerFooter.company.categoryArabic = root.businessTypeArabic;
                                root.headerFooter.company.categoryEnglish = root.businessTypeEnglish;

                                root.headerFooter.company.companyNameArabic = root.companyNameArabic;
                                root.headerFooter.company.companyNameEnglish = root.companyNameEnglish;
                                root.headerFooter.company.logoPath = root.businessLogo;

                            }
                            root.getBase64Image(root.headerFooter.company.logoPath);
                        }
                    });
            },
            ViewInvoiceTemplate: function (value) {
                debugger;
                this.GetHeaderDetail();

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetailsPos = [];
                root.$https.get("/Sale/SaleDetail?id=" + value, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {
                            root.$router.push({
                                
                                path: '/SaleServiceView',
                                query: {
                                    printDetails: response.data,
                                    headerFooter: root.headerFooter,
                                }
                            })

                            
                        }
                    });
            },
            PrintInvoice: function (value, prop) {
                debugger;
                this.GetHeaderDetail();

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetailsPos = [];
                root.$https.get("/Sale/SaleDetail?id=" + value, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {

                            root.printDetails = response.data;

                            if (prop == 'download') {
                                root.download = true;
                                root.isPrint = false;
                            }
                            else {
                                root.download = false;
                                root.isPrint = true;
                                root.printRender++;
                            }
                        }
                    });
            },
            GetInvoicePrintSetting: function () {
                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Sale/printSettingDetail', { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {

                            root.headerFooter.footerEn = response.data.termsInEng;
                            root.headerFooter.footerAr = response.data.termsInAr;
                            root.headerFooter.isHeaderFooter = response.data.isHeaderFooter;
                            root.headerFooter.englishName = response.data.englishName;
                            root.headerFooter.arabicName = response.data.arabicName;
                            root.headerFooter.customerAddress = response.data.customerAddress;
                            root.headerFooter.customerVat = response.data.customerVat;
                            root.headerFooter.customerNumber = response.data.customerNumber;
                            root.headerFooter.cargoName = response.data.cargoName;
                            root.headerFooter.customerTelephone = response.data.customerTelephone;
                            root.headerFooter.itemPieceSize = response.data.itemPieceSize;
                            root.headerFooter.styleNo = response.data.styleNo;
                            root.headerFooter.blindPrint = response.data.blindPrint;
                            root.headerFooter.showBankAccount = response.data.showBankAccount;
                            root.headerFooter.bankAccount1 = response.data.bankAccount1;
                            root.headerFooter.bankAccount2 = response.data.bankAccount2;
                            root.headerFooter.bankIcon1 = response.data.bankIcon1;
                            root.headerFooter.bankIcon2 = response.data.bankIcon2;
                            root.headerFooter.customerNameEn = response.data.customerNameEn;
                            root.headerFooter.customerNameAr = response.data.customerNameAr;
                            root.headerFooter.exchangeDays = response.data.exchangeDays;
                            root.headerFooter.printOptions = response.data.printOptions;
                            root.headerFooter.invoicePrint = response.data.invoicePrint;
                            root.headerFooter.welcomeLineEn = response.data.welcomeLineEn;
                            root.headerFooter.welcomeLineAr = response.data.welcomeLineAr;
                            root.headerFooter.closingLineEn = response.data.closingLineEn;
                            root.headerFooter.closingLineAr = response.data.closingLineAr;
                            root.headerFooter.contactNo = response.data.contactNo;
                            root.headerFooter.managementNo = response.data.managementNo;

                            root.headerFooter.businessAddressArabic = response.data.businessAddressArabic;
                            root.headerFooter.businessAddressEnglish = response.data.businessAddressEnglish;
                            root.headerFooter.headerImage = response.data.headerImageForPrint;
                            root.headerFooter.footerImage = response.data.footerImageForPrint;
                        }

                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },
            PrintInvoicePos: function (value, counterName) {

                this.GetHeaderDetail();
                var root = this;
                var token = '';
                this.isDisabled = true;
                this.PrinterInterval();
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.printDetails = [];
                root.$https.get("/Sale/SaleDetail?id=" + value, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then(function (response) {
                        if (response.data != null) {
                            root.printDetailsPos = response.data;
                            root.printDetailsPos.counterName = counterName;
                            root.printRenderPos++;
                        }
                    });
            }
        },
        created: function () {

            this.GetHeaderDetail();

            if (this.$route.query.data == 'addSaleService') {
                this.$emit('input', 'addSaleService');

            }
            else {
                this.$emit('input', this.$route.name);

            }
        },
        mounted: function () {
            this.overWrite = localStorage.getItem('overWrite') == 'true' ? true : false;

            this.businessLogo = localStorage.getItem('BusinessLogo');
            this.businessNameArabic = localStorage.getItem('BusinessNameArabic');
            this.businessNameEnglish = localStorage.getItem('BusinessNameEnglish');
            this.businessTypeArabic = localStorage.getItem('BusinessTypeArabic');
            this.businessTypeEnglish = localStorage.getItem('BusinessTypeEnglish');
            this.companyNameArabic = localStorage.getItem('CompanyNameArabic');
            this.companyNameEnglish = localStorage.getItem('CompanyNameEnglish');

            this.bankDetail = localStorage.getItem('BankDetail') == 'true' ? true : false;
            if (localStorage.getItem('fromDate') != null && localStorage.getItem('fromDate') != '' && localStorage.getItem('fromDate') != undefined) {
                this.fromDate = localStorage.getItem('fromDate');

            }
            else {
                this.fromDate = moment().add(-7, 'days').format("DD MMM YYYY");

            }
            if (localStorage.getItem('toDate') != null && localStorage.getItem('toDate') != '' && localStorage.getItem('toDate') != undefined) {
                this.toDate = localStorage.getItem('toDate');

            }
            else {
                this.toDate = moment().format("DD MMM YYYY");
            }
            var IsDayStart = localStorage.getItem('DayStart');
            this.isDayStarts = localStorage.getItem('DayStart');
            var IsDayStartOn = localStorage.getItem('IsDayStart');
            this.printTemplate = localStorage.getItem('PrintTemplate');
            this.printSize = localStorage.getItem('PrintSizeA4');

            var AllowAll = localStorage.getItem('AllowAll');
            if (IsDayStart != 'true') {
                this.isDayAlreadyStart = true;
                this.english = localStorage.getItem('English');
                this.arabic = localStorage.getItem('Arabic');
                this.search = '';
                if (localStorage.getItem('active') != null && localStorage.getItem('active') != '' && localStorage.getItem('active') != undefined) {
                    this.currentPage = parseInt(localStorage.getItem('currentPage'));
                    this.active = (localStorage.getItem('active'));
                    if (this.active == 'Draft' || this.active == 'post' || this.active == 'Approved' || this.active == 'Void' || this.active == 'Rejected') {
                        this.active = 'Hold';

                    }
                    this.getPage();

                }
                else {
                    if (this.isValid('CanViewHoldServiceInvoices')) {
                        this.active = 'Hold';
                    }
                    else if (this.isValid('CanViewPaidServiceInvoices')) {
                        this.active = 'Paid';
                    }
                    else if (this.isValid('CanViewCreditServiceInvoices')) {
                        this.active = 'Credit';
                    }

                    this.getPage();

                }
                this.currency = localStorage.getItem('currency');
                this.companyId = localStorage.getItem('CompanyID');
                //this.headerFooter.footerEn = localStorage.getItem('TermsInEng');
                //this.headerFooter.footerAr = localStorage.getItem('TermsInAr');
            }
            else {
                if (AllowAll == 'true') {
                    this.isDayAlreadyStart = true;
                    this.english = localStorage.getItem('English');
                    this.arabic = localStorage.getItem('Arabic');
                    this.search = '';
                    if (localStorage.getItem('active') != null && localStorage.getItem('active') != '' && localStorage.getItem('active') != undefined) {
                        this.currentPage = parseInt(localStorage.getItem('currentPage'));
                        this.active = (localStorage.getItem('active'));
                        if (this.active == 'Draft') {
                            this.active = 'Hold';

                        }
                        this.getPage();

                    }
                    else {
                        if (this.isValid('CanViewHoldServiceInvoices')) {
                            this.active = 'Hold';
                        }
                        else if (this.isValid('CanViewPaidServiceInvoices')) {
                            this.active = 'Paid';
                        }
                        else if (this.isValid('CanViewCreditServiceInvoices')) {
                            this.active = 'Credit';
                        }

                        this.getPage();

                    }
                    this.currency = localStorage.getItem('currency');
                    this.companyId = localStorage.getItem('CompanyID');
                    //this.headerFooter.footerEn = localStorage.getItem('TermsInEng');
                    //this.headerFooter.footerAr = localStorage.getItem('TermsInAr');
                }
                else if (IsDayStartOn == 'true') {
                    this.isDayAlreadyStart = true;
                    this.english = localStorage.getItem('English');
                    this.arabic = localStorage.getItem('Arabic');
                    this.search = '';
                    if (localStorage.getItem('active') != null && localStorage.getItem('active') != '' && localStorage.getItem('active') != undefined) {
                        if (localStorage.getItem('currentPage') != null && localStorage.getItem('currentPage') != '' && localStorage.getItem('currentPage') != undefined) {
                            this.currentPage = parseInt(localStorage.getItem('currentPage'));

                        }
                        else {
                            this.currentPage = 1;
                        }
                        this.active = (localStorage.getItem('active'));
                        if (this.active == 'Draft') {
                            this.active = 'Hold';

                        }
                        if (this.active == 'Approved') {
                            this.active = 'Hold';

                        }
                        this.getPage();

                    }
                    else {
                        if (this.isValid('CanViewHoldServiceInvoices')) {
                            this.active = 'Hold';
                        }
                        else if (this.isValid('CanViewPaidServiceInvoices')) {
                            this.active = 'Paid';
                        }
                        else if (this.isValid('CanViewCreditServiceInvoices')) {
                            this.active = 'Credit';
                        }
                        this.getPage();

                    }
                    this.currency = localStorage.getItem('currency');
                    this.companyId = localStorage.getItem('CompanyID');
                    //this.headerFooter.footerEn = localStorage.getItem('TermsInEng');
                    //this.headerFooter.footerAr = localStorage.getItem('TermsInAr');
                }
                else {

                    this.CompanyID = localStorage.getItem('CompanyID');
                    this.UserID = localStorage.getItem('UserID');
                    this.employeeId = localStorage.getItem('EmployeeId');
                    this.isDayAlreadyStart = false;
                }
            }
        },
    }
</script>
<style scoped>
    .vue__time-picker input.display-time {
        height: 40px !important;
        background-color: #f2f6f9;
        border: 1px solid #f2f6f9;
    }
</style>